import { render, staticRenderFns } from "./TsAudioRecorder.vue?vue&type=template&id=26a1a41e&scoped=true"
import script from "./TsAudioRecorder.vue?vue&type=script&lang=js"
export * from "./TsAudioRecorder.vue?vue&type=script&lang=js"
import style0 from "./TsAudioRecorder.vue?vue&type=style&index=0&id=26a1a41e&prod&scoped=true&lang=css"
import style1 from "./TsAudioRecorder.vue?vue&type=style&index=1&id=26a1a41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a1a41e",
  null
  
)

export default component.exports